/* eslint-disable import/no-default-export */
export default {
  Forbidden: 'Forbidden',
  Length: 'The "{{label}}" is between a minimum of {{Min}} letters and a maximum of {{Max}} letters',
  LengthLong: 'The max length is {{max}} characters',
  LengthShort: 'The min length is {{min}} characters',
  NoSpecialCharacters: 'The "{{label}}" cannot contain special characters',
  NotEmpty: 'Field can not be empty.',
  Required: 'The "{{label}}" field is mandatory',
  ServerError: 'Server error',
  Warning: 'Warning',
  ForbiddenText: 'Sorry, you are not authorized to access this page.',
  MinMax: 'Value must be between {{min}} and {{max}}',
  NotEmail: 'This is not a valid email.',
  OnlyNumbersOrSpace: 'The {{Label}} can contains only numbers or space'
}
